import Box from '@mui/material/Box';

import usePwa from '../../../hooks/providers/usePwa';
import {capitalizeWord} from '../../../utils';
import Button from '../../form/buttons/Button/Button';

const AndroidPwaPrompt = () => {
  const {handleWebInstallAccept: onAccept} = usePwa();
  const companyName = capitalizeWord(import.meta.env.VITE_HUMANIZED_NAME);

  return (
    <Box px={1} pb={2}>
      <Button variant="contained" color="primary" size="large" sx={{width: '50vw'}} onClick={onAccept}>
        Installer {companyName}
      </Button>
    </Box>
  );
};

export default AndroidPwaPrompt;
